<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="25rem"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        small
        text
        color="success"
        class="btn-success-transparent"
      >
        <v-icon x-small left>fa-plus</v-icon>
        Nouvelle alerte
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="px-1 pt-1">
        <v-row justify="end" no-gutters dense>
          <v-btn small icon text @click="dialog = false" :disabled="saving">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-form v-model="valid" @submit.prevent="save">
        <v-card-text class="pb-1">
          <v-row no-gutters align="center" dense>
            <v-autocomplete
              filled
              dense
              class="no-before"
              required
              v-model="data.product"
              :items="getProducts"
              item-text="nom"
              item-value="id"
              label="Produit"
            ></v-autocomplete>
          </v-row>
          <v-row no-gutters align="center" dense>
            <j-decimal-input
              filled
              dense
              class="no-before"
              required
              :min="0"
              v-model="data.quantity"
              label="Seuil"
              :suffix="getUnit"
            ></j-decimal-input>
          </v-row>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-row no-gutters dense justify="end">
            <v-btn
              :block="$vuetify.breakpoint.xsOnly"
              :small="!$vuetify.breakpoint.xsOnly"
              :class="{ 'mt-3': $vuetify.breakpoint.xsOnly }"
              color="success"
              :disabled="!valid || saving"
              type="submit"
            >
              <v-icon x-small left>fa-save</v-icon>
              Enregistrer
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
export default {
  name: "InventoryAlertCreator",
  computed: {
    ...mapGetters(["getProducts", "getStoreId"]),
    getUnit() {
      if (this.data.product !== null) {
        const product = this.getProducts.find(x => x.id === this.data.product);
        if (product) {
          return product.data ? product.data.unite_mesure_inventory : "";
        } else {
          return "";
        }
      } else {
        return "";
      }
    }
  },
  data() {
    return {
      dialog: false,
      valid: false,
      saving: false,
      data: {
        product: null,
        quantity: 0
      }
    };
  },
  methods: {
    async save() {
      if (this.valid === true) {
        try {
          this.saving = true;
          const d = {
            ...this.data,
            store: this.getStoreId
          };
          await api.postInventoryAlert(d);
        } finally {
          this.$emit("create");
          this.saving = false;
          this.dialog = false;
        }
      }
    },
    reset() {
      this.data = {
        product: null,
        quantity: 0
      };
    }
  },
  watch: {
    dialog() {
      this.reset();
    }
  }
};
</script>

<style></style>
